import React from 'react';
import { useCart } from '../../context/CartContext';
import './Toast.css';

const Toast = () => {
  const { toast, isOpen, toggleCart } = useCart();

  if (!toast) return null;

  const handleClick = () => {
    if (!isOpen) {
      toggleCart();
    }
  };

  return (
    <button
      type="button"
      className="toast"
      onClick={handleClick}
      aria-label={`${toast} added to cart. View cart.`}
    >
      <span className="toast-icon">✓</span>
      <div className="toast-text">
        <span className="toast-title">Added to cart</span>
        <span className="toast-item">{toast}</span>
      </div>
      <span className="toast-action">View cart →</span>
    </button>
  );
};

export default Toast;
